import styled from "styled-components";

const Badge = styled.span<{ $color: string }>`
    font-size: 13px;
    padding: 2px 10px;
    border-radius: 999px;
    border: 1px solid ${({ $color }) => $color};
    color: ${({ $color }) => $color};
`;

/** Running, done or failed. */
export function StatusBadge({ exitCode }: { exitCode: number | undefined }) {
    if (exitCode === undefined) return <Badge $color="var(--busy)">running</Badge>;
    if (exitCode === 0) return <Badge $color="var(--good)">done</Badge>;

    return <Badge $color="var(--bad)">failed ({exitCode})</Badge>;
}
